import React from "react"

import "./layoutIndustries.scss"

const LayoutIndustries = (props) => {
  const {
    title,
    logo,
    description,
    video,
    content,
    summary,
    summary_logo,
  } = props
  return (
    <div className="layout-industries-wrapper">
      <div className="layout-industries-head">
        <div className="image-wrapper">
          <img
            src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${logo.path}`}
            alt=""
          />
        </div>
        <div className="layout-industries-title">
          <h1>{title}</h1>
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: description }}
          ></div>
        </div>
      </div>
      <div
        className="video-wrapper"
        dangerouslySetInnerHTML={{ __html: video.assets.iframe }}
      ></div>
      {content.map((card, index) => {
        return (
          <div className="card-wrapper" key={index}>
            <div className="card-title">{card.value.text_card_title}</div>
            <div
              className="card-ul"
              dangerouslySetInnerHTML={{
                __html: card.value.wysiwyg_card_content,
              }}
            ></div>
          </div>
        )
      })}
      <div className="summary-wrapper">
        <img
          className="summary_logo"
          src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${summary_logo.path}`}
          alt="summary_logo"
        />
        <div
          className="summary"
          dangerouslySetInnerHTML={{ __html: summary }}
        ></div>
      </div>
    </div>
  )
}

export default LayoutIndustries
